import React from 'react';

import { observer } from 'mobx-react';

import { useStores } from 'bringg-web/recipes';

interface Props {
	userId: number;
}

function CreatorNameCell({ userId }: Props) {
	const { driversStore } = useStores();

	return <span>{userId ? driversStore.get(userId)?.name : '–'}</span>;
}

export default observer(CreatorNameCell);
